



































































import { computed, ref } from 'vue';
import { mediaTypes } from '../enums/mediaTypes';
import { parentTypes } from '../enums/parentTypes';
import { attachmentStatus } from '../enums/attachmentStatus.js';
import { conversionStatusTypes } from '../enums/conversionStatusTypes';

import VideoThumbnail from '../PageFragments/Media/VideoThumbnail.vue';
import SoundThumbnail from '../PageFragments/Media/SoundThumbnail.vue';
import ImageThumbnail from '../PageFragments/Media/ImageThumbnail.vue';
import { useMediaScan } from '../composables/useMediaScan';
import { MediaModel } from '../models/media.model';
import { ScanningStatusEnum } from '../enums/scanningStatus.enum';
import { mediaUtil } from '../utils/mediaUtil';
import { useUserProfileStore } from '../stores';

export default {
  components: { ImageThumbnail, SoundThumbnail, VideoThumbnail },
  props: {
    attachments: { type: Array, default: () => [] },
    parent: { type: String, default: null },
  },
  emits: ['attachmentClicked'],
  setup(props, { emit }) {
    const lastThumbnailIndex = ref(3);
    const { institutionProfile } = useUserProfileStore();

    const getAttachedMedia = computed(() => {
      let attachedMedia = [];
      const onlyMediaTypes = [mediaTypes.SOUND, mediaTypes.IMAGE, mediaTypes.VIDEO];
      const onlyAttachedStatus = [attachmentStatus.PENDING, attachmentStatus.AVAILABLE];
      if (props.attachments != null && props.attachments.length > 0) {
        attachedMedia = props.attachments.filter(
          (a: any) =>
            onlyAttachedStatus.includes(a.status) && a.media != null && onlyMediaTypes.includes(a.media.mediaType)
        );
      }
      return mediaUtil.filterScannedMediaForProfile(attachedMedia, institutionProfile.profileId);
    });

    const getScanningText = (media: MediaModel) => {
      const mediaRef = ref(media);
      const { scanningText } = useMediaScan(mediaRef);
      return scanningText.value;
    };

    const isMediaDisabled = (media: MediaModel) => {
      const mediaRef = ref(media);
      const { isMediaDisabled } = useMediaScan(mediaRef);
      return isMediaDisabled.value;
    };

    const downloadAttachment = (attachment: any) => {
      window.location = attachment.media.file.url;
    };

    const openMedia = (attachment: any) => {
      if (attachment.media.conversionStatus === conversionStatusTypes.PROCESSING) {
        return;
      }

      // Block clicks if media is processing or blocked
      if (isMediaDisabled(attachment.media)) {
        return;
      }

      emit('attachmentClicked', attachment.media.id);
    };

    return {
      mediaTypes,
      parentTypes,
      ScanningStatusEnum,
      attachmentStatus,
      lastThumbnailIndex,
      conversionStatus: conversionStatusTypes,
      getAttachedMedia,
      getScanningText,
      isMediaDisabled,
      downloadAttachment,
      openMedia,
    };
  },
};
